const pad2 = (value: number, fillString: string) => String(value).padStart(2, fillString)

const numberFormat = Intl.NumberFormat()

const ja = {
  formatNumber: (n: number) => {
    const s = numberFormat.format(n)
    return s === '-0' ? '0' : s
  },
  formatDateTime: (epochMilliseconds: number, options?: { year?: boolean }) => {
    if (!epochMilliseconds) {
      return ''
    }
    const now = new Date()
    const date = new Date(epochMilliseconds)
    const year = date.getFullYear()
    return `${options?.year || (options?.year !== false && now.getFullYear() !== year) ? `${year}年` : ''}${pad2(
      date.getMonth() + 1,
      ' ',
    )}月${pad2(date.getDate(), ' ')}日 ${pad2(date.getHours(), '0')}:${pad2(date.getMinutes(), '0')}`
  },
  formatRelativeDateTimeFromNow: (epochMilliseconds: number, now = Date.now()) => {
    const diff = now - epochMilliseconds
    const s = 1000
    const m = s * 60
    const h = m * 60
    const d = h * 24
    if (diff >= 0) {
      if (diff < m) return 'たった今'
      if (diff < h) return `${Math.floor(diff / m)}分前`
      if (diff < d) return `${Math.floor(diff / h)}時間前`
      if (diff < d * 30) return `${Math.floor(diff / d)}日前`
    }
    return ja.formatDateTime(epochMilliseconds)
  },
  MMdd: (date: Date) => `${pad2(date.getMonth() + 1, ' ')}月${pad2(date.getDate(), ' ')}日`,
  yyyyMMdd: (date: Date) => `${date.getFullYear()}年${pad2(date.getMonth() + 1, ' ')}月${pad2(date.getDate(), ' ')}日`,
  MMddHHmm: (date: Date) =>
    `${pad2(date.getMonth() + 1, ' ')}月${pad2(date.getDate(), ' ')}日 ${pad2(date.getHours(), '0')}:${pad2(date.getMinutes(), '0')}`,

  serviceName: 'GENKEI MARKUP',
  doodleDocumentTitle: (filename: string) => `${filename} - GENKEI MARKUP`,

  inUse: '使用中',
  changeFilename: 'ファイル名変更',
  changePassword: 'パスワード変更',
  login: 'ログイン',
  logout: 'ログアウト',
  pleaseLogin: 'ログインしてください。',
  paymentRequired: 'ライセンスが有効期限切れです。',
  permissionDenied: '権限がありません。',
  notFound: '対象が見つかりません。',
  mayDeleted: '対象が見つかりません。削除された可能性があります。',

  unauthorized: {
    invalidEmailOrInvitationCode: 'メールアドレスまたは招待コードが不正です。',
    unshared: 'この招待コードは無効化されました。',
    authorIsDisabled: '図面所有者様の都合によりアクセスできません。',
  },

  notice: 'お知らせ',
  help: 'ヘルプ',
  about: `GENKEI MARKUP について`,
  contact: 'お問い合わせ',
  contactUrl: 'https://genkei.co.jp/contact/',
  termsOfUse: '利用規約',
  termsOfUseUrl: 'https://genkei.co.jp/terms/',
  privacyStatement: 'プライバシーポリシー',
  privacyStatementUrl: 'https://genkei.co.jp/privacy/',
  userManual: '使い方ガイド（図面所有者向け）',
  userManualUrl: 'https://genkei.co.jp/pdf/GENKEI_MARKUP.pdf',
  guestManual: '使い方ガイド（招待された方向け）',
  guestManualUrl: 'https://genkei.co.jp/pdf/GENKEI_MARKUP_for_guest.pdf',
  signUpForTrial: '無料試用お申し込み',
  signUpForPaid: '有償版お申し込み',

  filename: 'ファイル名',
  ownedBy: '所有者',
  createdBy: '作成者',
  updatedBy: '更新者',
  createdAt: '作成日時',
  updatedAt: '更新日時',
  storage: 'ストレージ',
  storageUsage: 'ストレージ使用量',
  updated: '更新',
  handover: {
    handover: '譲渡',
    handoverDoodle: '図面を譲渡する',
    handoverFolder: 'フォルダーを譲渡する',
    drawingName: '図面名',
    folderName: 'フォルダー名',
    newOwner: '新しい所有者',
    selectNewOwner: '選択してください...',
    message: {
      handoverTenantSharingDoodle: '図面の所有者を変更します。\n譲渡するとあなたは譲渡や削除ができなくなります。',
      handoverPersonalDoodle: '図面の所有者を変更します。\n譲渡するとあなたはアクセスできなくなります。',
      handoverPersonalFolder: 'フォルダーとフォルダー内の図面の所有者を変更します。\n譲渡するとあなたはアクセスできなくなります。',
    },
  },

  open: '開く',
  close: '閉じる',
  save: '保存',
  cancel: 'キャンセル',
  edit: '編集',
  copy: 'コピー',
  delete: '削除',
  reply: '返信',
  fileMenu: 'ファイル',
  undo: '元に戻す',
  redo: 'やり直す',
  rotate: '回転',
  rename: '名前変更',
  create: '作成',
  select: '選択',
  cancelSelection: '選択キャンセル',
  nDoodlesAreSelected: (n: number) => `${n} 件選択中`,
  search: '検索',
  filenameSearch: 'ファイル名検索',
  searchResult: {
    notFound: '見つかりませんでした',
    hitsTooMany: '検索結果が 100 件を超えました。文字数を増やして再検索してください。',
  },

  deleteSelectedDoodles: '削除',
  downloadEachPdf: 'PDF ダウンロード',
  downloadConcatenatedDoodles: '図面を結合して\nPDF ダウンロード',
  doodleListFormats: {
    card: 'カード表示',
    table: 'リスト表示',
  },

  folderName: 'フォルダー名',
  folders: 'フォルダー',
  personalFolders: '個人フォルダー',
  tenantFolders: '社内フォルダー',
  rootFolderName: '（未整理）',
  folderIsEmpty: '図面はまだありません',
  addDrawings: '図面追加',
  groupByAuthor: '作成者ごと',
  confirmDelete: '削除しますか？',
  confirmDeleteWithName: (name: string) => `${name} を削除しますか？`,
  confirmDeleteMany: (count: number) => `${count}件 削除しますか？`,
  confirmMovingFromTenantSharedToPersonalFolder: '社内フォルダーから個人フォルダーへ移動すると、共有が解除されます。\nよろしいですか？',
  uploading: '読み込んでいます...',
  errorOccurred: 'エラーが発生しました。',
  errorWithCode: (code: string) => `エラーが発生しました。コード: ${code}`,
  errorWithStatus: (status: number) => `エラーが発生しました。ステータスコード: ${status}`,
  networkErrorOccurred: '通信エラーが発生しました。',
  renderingErrorOccurred: '描画エラーが発生しました。',
  authErrorOccurred: '認証エラーが発生しました。\n再読み込みします。',
  reloadingSinceFileNotFound: 'ファイルが見つかりません。\n削除された可能性があります。\n再読み込みします。',
  unsupportedContentType: 'ファイル形式が不正です。',
  unsupportedInputFileType: '未対応のファイル形式です。',
  disconnected: '切断されました。',
  decreaseResolutionSincePdfPageSizeTooLarge: '用紙サイズが大きいため、端末に合わせて\n解像度を調整しています。',
  permissionDeniedForSomeDoodles: '自身が所有者でないファイルが含まれているため削除できません。',

  reload: '再読み込み',

  print: '印刷',
  downloadPdf_: 'PDF ダウンロード...',
  downloadPng: 'PNG ダウンロード',
  downloadCurrentPageAsPng: 'PNG ダウンロード（現在のページのみ）',
  finalize: '最終化',
  finalized: '最終版',
  finalizeConfirm: '最終化すると、以後編集できなくなります。この操作は元に戻せません。\n\n最終化してよろしいですか？',

  history: '編集履歴',
  pageNumber: 'ページ',
  previousPage: '前へ',
  nextPage: '次へ',
  pageState: {
    annotated: '描き込みあり',
  },
  zoom: '拡大率',
  zoomIn: '拡大',
  zoomOut: '縮小',
  layer: 'レイヤー',
  layers: 'レイヤー',
  newLayer: '新しいレイヤー',
  dragLayerToReorder: 'ドラッグして表示順序を変更する\n（一覧の上側が手前）',
  toggleLayerVisibility: '表示／非表示を切り替える',
  editLayerName: 'レイヤー名編集',
  activateLayerName: (layerName: string) => `描き込み先を ${layerName} にする`,
  enterNewLayerName: '新しいレイヤー名を入力してください',
  externalApp: '外部アプリ',
  originalDrawing: '元図面',
  showsOriginal: '元図面表示',
  adjustToWidth: '幅に合わせる',
  adjustToSize: '全体表示',
  showsSpreadsheet: '表計算',
  spreadsheet: {
    downloadSpreadsheetCsv: '表計算 CSV ダウンロード',
    dockRight: '右に固定',
    dockBottom: '下に固定',
  },

  userCursorPageTemplate: (page: number) => ` (${page}ページ)`,

  pdfDownloadDialog: {
    caption: 'PDF ダウンロード',
    pageRange: 'ページ範囲',
    allPages: '全ページ',
    currentPage: (currentPageNumber: number) => `現在のページ (${currentPageNumber})`,
    specifiedPages: 'ページ指定',
    specifiedPagesDescription:
      'ページ番号またはページ範囲をカンマ区切りで入力してください。\n例: 「1, 4-6, 8, 10-12」→ 1, 4, 5, 6, 8, 10, 11, 12 ページ',
    invalidSpecifiedPageNumbers: (totalPageCount: number) =>
      `ページ番号が不正です。\n1 以上 ${totalPageCount} 以下のページ番号を組み合わせて指定してください。`,
    contentToBeOutput: '対象',
    outputsDoodleOnly: '図面のみ',
    outputsDoodleAndCommentList: '図面 ＋ コメント一覧表',
    includesComments: 'コメント一覧表',
    includesSpreadsheet: 'スプレッドシート',
  },

  share: '共有',
  permissions: {
    none: '権限なし',
    read: '読み込み',
    write: '読み書き',
  },
  sharing: {
    config: '共有設定',
    sharedUserCount: '共有人数',
    sharedGuestCount: '社外ゲスト',
    nPeople: (n: number) => `${n} 人`,
    blackOutDescription: '機密情報は共有前に「墨消し適用」機能で消去してください。',
    inviteTenantMember: '社内メンバー招待',
    inviteGuest: 'ゲスト招待（メールアドレス入力）',
    invite: '招待',
    maxSharingUserCountExceeded: '最大共有人数を超えています。',
    cantInviteYourself: '自分自身は招待できません。',
    invitedYet: (target: string) => `${target} はすでに招待済みです。`,
    confirmInvitation: (target: string) => `${target} に招待メールを送信します。\nよろしいですか？`,
    sentInvitationMail: '招待メールを送信しました。',
    unshare: '共有解除',
    editPermission: '編集権限',
    editPermissionDescription: '図形やコメントの挿入・編集可否を設定します。',
    outputPermission: 'DL権限',
    outputPermissionDescription: '［PDF ダウンロード］および［PNG ダウンロード］の実行可否を設定します。',
    spreadsheetEditPermission: '表計算編集',
    spreadsheetEditPermissionLong: '表計算編集権限',
    spreadsheetEditPermissionDescription: '表計算シート編集可否を設定します。',
    confirmUnsharing: '共有解除しますか？',
    sharedFolder: '共有フォルダー',
    sharedDoodleCannotMoveToSharedFolder: '共有図面は共有フォルダーへ移動できません。',
    confirmUnsharingByMovingFromSharedFolder: '共有フォルダーから移動すると、共有設定が解除されます。よろしいですか？',
  },
  contacts: {
    caption: 'アドレス帳',
    name: '名前',
    sortKey: 'ふりがな（並び順）',
    email: 'メール',
    newContact: '新しい連絡先',
    editContact: '連絡先編集',
    maxContactsExceeded: 'これ以上登録できません。',
    confirmationCaption: '権限設定',
    deleteContacts: (n: number) => `${n}件削除`,
    confirmationDescription: (n: number) => `下記 ${n} 人をこの図面に招待します。\n権限を設定してください。`,
    loadError: (response: Response) => `${response.status}: アドレス帳の読み込みに失敗しました。`,
    inviteMany: (n: number, max: number) => `${n}人招待（残り${max}人）`,
    confirmDelete: (contacts: readonly { readonly name: string }[]) =>
      `下記 ${contacts.length} 件の連絡先を削除しますか？\n${contacts.map(c => ` - ${c.name}`).join('\n')}`,
    sameEmailExists: (newContact: { readonly email: string; readonly name: string }, existingContact: { readonly name: string }) =>
      `メール「${newContact.email}」はすでに「${existingContact.name}」という名前で登録されています。\n「${newContact.name}」として新たに登録しますか？`,
  },

  email: 'メールアドレス',
  joinWithInvitationCode: {
    doodleHeading: '招待コードを入力して図面を開く',
    folderHeading: '招待コードを入力してフォルダーを開く',
    invitationCode: '招待コード',
  },

  notify: 'メール送信',
  notification: {
    confirm: '送信しますか？',
    caption: 'メール送信',
    description: '共有者全員にメールを送信します。',
    subject: '件名',
    subjectPlaceholder: (filename: string) => `［GENKEI MARKUP］図面が更新されました ${filename} `,
    body: '本文',
    send: '送信',
    sent: '送信しました。',
  },

  tools: {
    select: '選択',
    pan: '手のひら',
    eraser: '消しゴム',
    freehand: '手書き',
    line: '直線',
    rectangle: '長方形',
    ellipse: '楕円',
    text: 'テキスト',
    checklist: 'チェック',
    clipDrawing: '図面抽出',
    clipDrawingHint: '図面の一部を画像として切り出します。切り出す矩形範囲をドラッグ選択してください。',
    image: '画像挿入',
    stamp: 'スタンプ',
    applyBlackOut: '墨消し適用',
    continuousInput: '連続入力',
  },
  imageSize: {
    size: 'サイズ',
    s: '小',
    m: '中',
    l: '大',
    original: 'オリジナル',
  },

  stamp: {
    add: 'スタンプ追加',
    delete: 'スタンプ削除',
    confirmDelete: (count: number) => `${count} 個のスタンプを削除しますか？`,
    registered: '登録済み',
    description: 'スタンプに名前をつけてください。',
    fileIsTooLarge: 'ファイルサイズが大きすぎます',
  },

  blackOut: {
    disabled: '共有図面は墨消し適用できません。',
    caption: '墨消し適用',
    description1:
      '機密情報を消去するには、長方形や楕円で該当箇所を塗り潰した上で、この「墨消し適用」を実行してください。\n図形で塗り潰しただけでは元の情報が残ったままです。共有する際にはご注意ください。',
    description2: '墨消し適用は共有前に実行してください。共有後は実行できなくなります。',
    description3:
      '墨消しを適用すると、元の図面と GENKEI MARKUP で描画した図形との合成画像から、新しく PDF ファイルを作成します。これまでに描画した図形は編集できなくなり、編集履歴やコメントはすべて失われます。\n\n墨消しを適用してよろしいですか？',
    apply: '墨消し適用',
    blackedOut: '墨消済',
  },

  comment: 'コメント',
  fontSize: 'サイズ',
  strokeWidth: '太さ',

  enclosureOptions: {
    none: '囲みなし',
    rectStroke: '四角囲み',
    rectFill: '白抜き四角',
    circleStroke: '丸囲み',
    circleFill: '白抜き丸',
  },

  strokeDasharrayName: {
    noStroke: '線なし',
    unbroken: '実線',
    dot: '点線',
    dashDot: '一点鎖線',
    dashDotDot: '二点鎖線',
  },

  lineEndOptions: {
    none: '端点なし',
    startArrow: '始点矢印',
    endArrow: '終点矢印',
    bidirectionalArrow: '両矢印',
  },

  fillOptions: {
    none: '塗りなし',
    hatching: '網掛け',
    translucent: '半透明',
    fill: '塗りつぶす',
  },

  color: '色',
  opacity: '不透明度',

  historyTable: {
    page: 'ページ',
    user: 'ユーザー',
    date: '日時',
  },

  checklist: {
    checkedChecklistIsUnremovable: 'チェック済み項目を含むチェックリストは削除できません',
    checkedItemIsUnremovable: 'チェック済み項目は削除できません',
  },

  downloadStatus: {
    caption: 'ダウンロードしています...',
    inProgress: '処理中',
    pending: '保留中',
  },

  downloadStatus2: {
    preparing: '準備しています...',
    progress: 'ページを構成しています...',
    finalizing: 'ファイルを構築しています...',
  },
} as const

export const i18n = ja
